export const API_BASE_URL = String(process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api').replace(/\/+$/, '');
